import { useDropzone, DropzoneOptions } from 'react-dropzone'

type PostBoxDropzoneProps = {
  children: any
} & DropzoneOptions

const PostBoxDropzone = ({ children, ...otherProps }: PostBoxDropzoneProps) => {
  const { getInputProps, getRootProps, isDragActive } = useDropzone({
    noClick: true,
    ...otherProps,
  })

  return (
    <div {...getRootProps()}>
      <input {...getInputProps()} />

      {isDragActive && (
        <div className="PostBox__dropzone">
          投稿したい写真をドラックドロップしてください。
        </div>
      )}

      {children}
    </div>
  )
}

export default PostBoxDropzone
